import { Accordion, AccordionSummary, AccordionDetails } from "@wealthx/ui";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import classNames from "classnames";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getCurrentPath } from "../../../utils/get-params-value";
import "./collapsible-menu-item.scss";

const CollapsibleMenuItem = ({
  icon,
  title,
  subItems = [],
  isActive = false,
  sidebarCollapse = false,
  onSubItemClick,
}) => {
  const [expanded, setExpanded] = useState(false);
  const pathName = getCurrentPath();
  // Auto-expand if any sub-item is active
  useEffect(() => {
    if (!sidebarCollapse) {
      const hasActiveSubItem = subItems.some((subItem) => pathName.includes(subItem.href));
      const timer = setTimeout(() => {
        setExpanded(hasActiveSubItem);
      }, 0);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [pathName, subItems, sidebarCollapse]);

  const handleChange = (event, isExpanded) => {
    if (!sidebarCollapse) {
      setExpanded(isExpanded);
    }
  };

  const handleSubItemClick = (subItem) => {
    if (onSubItemClick) {
      onSubItemClick(subItem);
    }
  };

  return (
    <div className="collapsible-menu-item">
      <Accordion
        className="position-relative"
        square
        expanded={expanded}
        onChange={handleChange}
        classes={{
          root: "collapsible-menu-item-accordion-root",
          expanded: "collapsible-menu-item-accordion-expanded",
        }}
      >
        <AccordionSummary
          aria-controls="collapsible-menu-item-content"
          id="collapsible-menu-item-header"
          classes={{
            root: "collapsible-menu-item-summary-root",
            content: "collapsible-menu-item-summary-content",
            expanded: "collapsible-menu-item-summary-expanded",
          }}
        >
          <div
            className={classNames("side-bar-item collapsible-menu-item__header", {
              selected: isActive,
            })}
          >
            <div className="side-bar-item__icon">{icon}</div>
            {!sidebarCollapse && (
              <>
                <div className="side-bar-item__title">{title}</div>
                <ExpandMoreIcon
                  className="collapsible-menu-item__expand-icon"
                  sx={{ color: "white" }}
                />
              </>
            )}
          </div>
        </AccordionSummary>
        {!sidebarCollapse && (
          <AccordionDetails
            className="collapsible-menu-item__details"
            classes={{
              root: "collapsible-menu-item-details-root",
            }}
          >
            <div className="w-100">
              {subItems.map((subItem) => {
                const subItemUrl = `/${subItem.href}`;
                return (
                  <Link
                    key={subItem.href}
                    to={subItemUrl}
                    className={classNames("collapsible-menu-item__sub-item", {
                      "collapsible-menu-item__sub-item--active": subItem.isActive,
                    })}
                    onClick={() => handleSubItemClick(subItem)}
                  >
                    {subItem.icon && <div className="side-bar-item__icon">{subItem.icon}</div>}
                    <div className="side-bar-item__title">{subItem.title}</div>
                  </Link>
                );
              })}
            </div>
          </AccordionDetails>
        )}
      </Accordion>
    </div>
  );
};

CollapsibleMenuItem.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  subItems: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      isActive: PropTypes.bool,
    })
  ),
  isActive: PropTypes.bool,
  sidebarCollapse: PropTypes.bool,
  onSubItemClick: PropTypes.func,
};

export default CollapsibleMenuItem;
